<template>
  <div id="loginBg">
  <header>
   <div style="display: flex;padding-top: 16px;padding-left: 63px;">
    <img
            src="../assets/images/logo.png"
            class="logo"
            style="width: 4%;"
            @click="$router.push({ path: '/' })"
          />
          <span
            style="
              color: #d7000f;
              font-family: Douyin Sans;
              font-size: 18px;
              font-style: normal;
              font-weight: 700;
              line-height: 20px; /* 83.333% */
            "
          >
            环境产业互联网平台
          </span>
   </div>
  </header>
    <el-row class="login-info" :style="styles">
      <el-col
        :span="24"
        style="
          margin-top: 5px;
          margin-bottom: 20px;
          font-size: 20px;
          text-align: left;
          margin-left: 20px;
          color: #000;
        "
      >
        <b>账号登录</b>
      </el-col>
      <el-col :span="24">
        <el-input
          class="login-input"
          placeholder="请输入手机号或账号"
          maxlength="16"
          v-model="account"
        ></el-input>
      </el-col>
      <el-col :span="24">
        <el-input
          class="login-input"
          show-password
          placeholder="密码"
          maxlength="16"
          v-model="password"
        ></el-input>
      </el-col>
      <el-col :span="24">
        <el-input class="login-input" placeholder="请输入验证码" v-model="captcha">
          <template slot="append">
            <img class="getCaptcha" :src="codesrc" @click="getImgCode" />
          </template>
        </el-input>
      </el-col>
      <el-col
        :span="12"
        class="text-left"
        style="margin-left: 20px; margin-bottom: 15px"
      >
        <span class="font-12 cursor-pointer" @click="toResetPWD">忘记密码</span>
      </el-col>
      <el-col :span="24">
        <el-button
          style="
            width: 90%;
            background: #d7000f99;
            border: none;
            border-radius: 0;
          "
          type="primary"
          :disabled="checked"
          @click="loginClick"
          >登录
        </el-button>
      </el-col>

      <el-col style="color: #000; margin-top: 15px" class="text-center">
        <!-- <img style="width: 18px;" src="../assets/images/Vector.png" alt="">
        <span>使用微信登录</span> -->
      </el-col>
      <el-col class="text-center">
        <span class="font-12 cursor-pointer" @click="toReg">立即注册</span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { Message } from "element-ui";
// import { mapGetters, mapActions } from 'vuex'

import { getEmail } from "@/api/doOneGood";
export default {
  name: "Login",
  data() {
    return {
      codesrc: null,
      randomStr: null,
      account: "",
      password: "",
      captcha: "",
      checked: false,
      autoQuery: "",
    };
  },
  created() {
    // console.log(this, 'this');
    this.getImgCode();
  },
  mounted() {
    this.autoQuery = this.$route.query;
    let auth = localStorage.getItem("usertoken");
    if (this.userName && !this.$route.query.appId) {
      this.$router.replace("/");
    } else {
      this.otherLogin(auth);
    }
  },
  computed: {
    styles() {
      return {
        width:
          this.$store.state.app.device == "desktop"
            ? "330px"
            : `${document.body.clientWidth - 10}px`,
        top: this.$store.state.app.device == "desktop" ? "18%" : "5%",
        left: this.$store.state.app.device == "desktop" ? "65%" : "5px",
      };
    },
    ...mapGetters(["userName"]),
  },
  methods: {
    ...mapMutations([
      "SET_NAME", //将mutation里的方法映射到该组件内
      //等同于this.$store.commit('DECREASE_SHOPCART')
    ]),

    // 跳转忘记密码
    toResetPWD() {
      this.$router.push({
        path: "/forestPwd",
      });
    },
    // 跳转注册
    toReg() {
      this.$router.push({ path: "/register" });
    },
    async getImgCode() {
      this.$axios({
        url: "/api/code",
        method: "get",
        responseType: "blob",
      }).then((res) => {
        const raw = res.data;
        const { randomstr } = res.headers;
        this.randomStr = randomstr;
        this.codesrc = window.URL.createObjectURL(raw);
      });
    },

    loginClick() {
      if (!this.$route.query.appId) {
        if (this.username == "") {
          this.$message.error("请输入登陆账号");
          return;
        }
        if (this.password == "") {
          this.$message.error("请输入账号密码");
          return;
        }
        if (this.captcha == "") {
          this.$message.error("请输入验证码");
          return;
        }
        var params = {
          username: this.account,
          password: this.password,
          captcha: this.captcha,
          randomStr: this.randomStr,
        };
        var that = this;
        this.$axios({
          url: "/api/auth/login",
          method: "post",
          data: params,
        })
          .then((res) => {
            if (res.data.code === 0) {
               Message({
                message: '登录成功',
                type: "success",
                duration: 1000
              });
              that.usertoken = res.data.token;
              that.userId = res.data.userId;
              // localStorage.setItem("userName", this.account);
              localStorage.setItem("userName", res.data.userName);
              localStorage.setItem("usertoken", res.data.token);
              localStorage.setItem("userId", res.data.userId);
              localStorage.setItem("phonenumber", res.data.phonenumber);
              localStorage.setItem("account", this.account);
              localStorage.setItem("password", this.password);
              getEmail({ email: res.data.email }).then((ress) => {
                if (ress.code != 200) return;
                localStorage.setItem("employeeId", ress.data.employeeId);
              });
              that.SET_NAME(res.data.userName);
              if(that.$route.query.id){
                // 从应用市场详情跳转出来，判断id,登陆后跳转到对应的应用详情
                that.$router.push({
                path: "/ApplicationDetail",
                query:{id:that.$route.query.id}
              });
              }else{
                that.$router.push({
                path: "/",
              });
              }

              // this.$axios({
              //   url: "/api/pt/tenant/getMyTenantInfo",
              //   method: "post",
              //   headers: {'token': this.usertoken}
              // })
              //   .then((res) => {
              //     localStorage.setItem("userType", res.data.code);
              //     location.href = "/";
              //   })
            } else {
              that.$message.error(res.data.msg);
              that.getImgCode();
            }
          })
          .catch((error) => {
            console.log(error.response.data.msg, "err");
            that.$message.error(error.response.data.msg);
            that.getImgCode();
          });
      } else {
        var that = this;
        if (this.username == "") {
          this.$message.error("请输入登陆账号");
          return;
        }
        if (this.password == "") {
          this.$message.error("请输入账号密码");
          return;
        }
        if (this.captcha == "") {
          this.$message.error("请输入验证码");
          return;
        }
        let paramsAuth = {
          appId: this.autoQuery.appId,
          username: this.account,
          password: this.password,
          redirectUri: this.autoQuery.redirectUri,
          captcha: this.captcha,
          state: this.autoQuery.state,
          randomStr: this.randomStr,
        };
        this.$axios({
          url: "/api/oapi/oauth2/login",
          method: "post",
          data: paramsAuth,
        })
          .then((res) => {
            if (res.data.code === 0) {
              localStorage.setItem(
                "userName",
                res.data.data.tokenInfo.userName
              );
              localStorage.setItem("usertoken", res.data.data.tokenInfo.token);
              localStorage.setItem("userId", res.data.data.tokenInfo.userId);
              window.location.href = res.data.data.redirectUri;
            } else {
              this.$message.error(res.data.msg);
              that.getImgCode();
            }
          })
          .catch((err) => {
            this.$message.error("登录错误，请重试！");
            that.getImgCode();

            // console.log(err);
          });
      }
    },
    otherLogin(autoToken) {
      if (autoToken && this.autoQuery.appId) {
        this.$axios({
          url: "/api/oapi/oauth2/auto/auth",
          method: "post",
          headers: { token: autoToken },
          data: {
            appId: this.autoQuery.appId,
            redirectUri: this.autoQuery.redirectUri,
            state: this.autoQuery.state,
          },
        }).then((res) => {
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          }
        });
      }
    },
  },
};
</script>


<style lang="scss" scope>
header{
  // background: #fff;
  height: 50px;
}
.getCaptcha {
  display: block;
  width: 100px;
  height: 35px;
}

#loginBg {
  text-align: center;
  // padding-top: 64px;
  width: 100%;
  height: 100vh;
  // height: 7rem;
  // height: calc(100vh - 414px);
  // min-height: 600px;
  // background-size: 90% 90%;
  background-image: url("../assets/images/login_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  // background: url("../assets/images/login.png") no-repeat #dbecdf;
  // background-position: center;
}

.login-info {
  position: relative;
  // left: 23%;
  // top: 18%;
  width: 330px;
  // margin: 0 auto;
  background-color: #fff;
  // box-shadow: 10px 10px 10px #f2f2f2;
  // border-radius: 10px;
  padding: 20px;
}

.foot-end {
  font-size: 12px;
  margin-top: 30px;
  padding-top: 10px;
  text-align: center;
  color: #939393;
  position: fixed;
  bottom: 0;
  margin: 0 auto;
  width: 100%;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.login-input {
  width: 90%;
  margin-bottom: 15px;

  ::v-deep .el-input-group__prepend {
    // img {
    //   width: 10000px;
    // }
    background: red;
  }
  .el-input__inner {
  //border: 1px solid #F9F9F9 !important;
  //background-color: #F9F9F9 !important;
}
.el-input__inner:hover {
  border-color: #D7000F !important;
}
.el-input-group__append{
  border: none;
}
}

.link {
  text-decoration: underline;
  color: #409eff;
}

.reg-text {
  font-size: 12px;
  text-align: right;
  width: 95%;
  margin-top: 10px;
}

.font-12 {
  font-size: 12px !important;
}

.cursor-pointer {
  cursor: pointer;
}

// .el-input-group__prepend {
//   // padding: 0 0 0 20px !important;
//   // background-color: red;
//   img {
//     width: 200px;
//   };
// }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue